import { ReactNode } from 'react'
import clsx from 'clsx'

interface PageContainerProps {
  children: ReactNode
  title: string
  subtitle?: string
  actions?: ReactNode
  className?: string
}

export default function PageContainer({
  children,
  title,
  subtitle,
  actions,
  className
}: PageContainerProps) {
  return (
    <div className={clsx('space-y-4', className)}>
      {/* Page Header */}
      <div className="flex items-start justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-surface-100">{title}</h1>
          {subtitle && (
            <p className="text-sm text-surface-400 mt-1">{subtitle}</p>
          )}
        </div>
        {actions && (
          <div className="flex items-center gap-2">
            {actions}
          </div>
        )}
      </div>

      {/* Page Content */}
      <div className="space-y-4">
        {children}
      </div>
    </div>
  )
}
